import { render, staticRenderFns } from "./ConversionsMX.vue?vue&type=template&id=5d0064e0&scoped=true"
import script from "./ConversionsMX.vue?vue&type=script&lang=js"
export * from "./ConversionsMX.vue?vue&type=script&lang=js"
import style0 from "./ConversionsMX.vue?vue&type=style&index=0&id=5d0064e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0064e0",
  null
  
)

export default component.exports